module.exports = {"title":"Four Ups","body":"<p>This document holds the results of the four-up exercises:</p>\n<ul>\n<li><a href=\"../files/Four-ups.docx\">Four Ups Doc</a></li>\n</ul>\n"}


/*****************
 ** WEBPACK FOOTER
 ** ./deliverables/four-ups/index.md
 ** module id = 468
 ** module chunks = 0
 **/